export default __webpack_public_path__ + "static/media/ies_FrankAgraz.86f92bab.png";